import { render, staticRenderFns } from "./MaterialSample.vue?vue&type=template&id=d08843f6&scoped=true&"
import script from "./MaterialSample.vue?vue&type=script&lang=js&"
export * from "./MaterialSample.vue?vue&type=script&lang=js&"
import style0 from "./MaterialSample.vue?vue&type=style&index=0&id=d08843f6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08843f6",
  null
  
)

export default component.exports